import { useSchedulingQuery as useQuery } from "./useSchedulingQuery";
import { getSchedule, listAllSchedules } from "../../components/api/Scheduling/schedules";
import { onError } from "./onError";

export const scheduleKeys = {
  list: (organizationRef, filters) => ["scheduling-schedules", organizationRef, filters],
  one: (organizationRef, scheduleId) => ["scheduling-schedule", organizationRef, scheduleId],
};

export function useSchedulesQuery({
  organizationRef,
  scope,
  excludedOrganizationRefs,
  practitionerRef,
  status,
  startsAt,
  endsAt,
  serviceCategoryId,
  onSuccess,
  enabled = true,
}) {
  const filters = { scope, excludedOrganizationRefs, practitionerRef, status, startsAt, endsAt, serviceCategoryId };
  return useQuery(
    scheduleKeys.list(organizationRef, filters),
    ({ signal, consistency }) => listAllSchedules({ organizationRef, ...filters, limit: 500, signal, consistency }),
    {
      enabled: !!organizationRef && enabled,
      keepPreviousData: false,
      staleTime: 30000, refetchOnWindowFocus: false, retry: false,
      onSuccess,
      onError,
    }
  );
}

export function useScheduleQuery({ organizationRef, scheduleId, onSuccess, enabled = true }) {
  return useQuery(
    scheduleKeys.one(organizationRef, scheduleId),
    async () => {
      const res = await getSchedule({ organizationRef, scheduleId });
      return res?.schedule || res;
    },
    {
      enabled: !!organizationRef && !!scheduleId && enabled,
      onSuccess,
      onError,
    }
  );
}
